module.exports = __webpack_public_path__ + "static/sch-about-67f0b1e976925ad7a188f1adf4b89aca.png";